import moment from 'moment';
import { WEEK, MONTH } from '../utils';

/**
 * The goal of this function is to normalize startDate or endDate in following cases:
 * viewBy MONTH - clear the day of the month
 * viewBy WEEK - reset hours of the day
 *
 * @param {*} viewBy WEEK | MONTH
 * @param {*} date task start date | task end date
 */
export const normalizeDateByBiew = (viewBy, date) => {
  if (viewBy === WEEK) {
    return new Date(
      `${date.getMonth() + 1}/${date.getDate()}/${date.getUTCFullYear()}`,
    );
  }
  if (viewBy === MONTH) {
    return new Date(`${date.getMonth() + 1}/01/${date.getUTCFullYear()}`);
  }

  return null;
};

export const getUnityAndFormat = viewBy => {
  switch (viewBy) {
    case WEEK:
      return { type: 'd', format: 'ddd, MM/DD' };

    default:
      return { type: 'M', format: 'MMM, YYYY' };
  }
};

export const buildHeadersBy = (viewBy, startDate) => {
  let result = [];
  const half = Math.floor(viewBy / 2);
  let indexAfterStart = 1;
  const { type, format } = getUnityAndFormat(viewBy);

  for (let index = 0; index < viewBy; index += 1) {
    const roudedDate = normalizeDateByBiew(viewBy, startDate);

    if (index <= half) {
      result = [
        {
          id: index,
          format,
          momentDate: moment(roudedDate).subtract(index, type),
          date: moment(roudedDate).subtract(index, type).toDate(),
        },
      ].concat(result);
    } else {
      result.push({
        id: index,
        format,
        momentDate: moment(roudedDate).add(indexAfterStart, type),
        date: moment(roudedDate).add(indexAfterStart, type).toDate(),
      });

      indexAfterStart += 1;
    }
  }

  result = result.map((r, index) => ({ ...r, id: index }));
  // for (let index = 0; index < viewBy; index += 1) {
  //   result.push({
  //     id: index,
  //     format,
  //     momentDate: moment(startDate).add(index, type),
  //     date: moment(startDate).add(index, type).toDate(),
  //   });
  // }
  return result;
};

export const generateHeaders = (viewBy, startDate) => {
  switch (viewBy) {
    case WEEK:
      return buildHeadersBy(WEEK, startDate);

    default:
      return buildHeadersBy(MONTH, startDate);
  }
};
